export default "__VITE_ASSET__UAuQc_OC__"